import graphql__29da1a4fd9c50a8f7943 from "./__generated__/FormDisclaimer_contribution.graphql.js";import { useState, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import Modal from "../Modals/Modal";
import FormStartButton from "./FormStartButton";
import AnonymousContributionSwitch from "../Contributions/AnonymousContribution/AnonymousContributionSwitch";
import { useFormatMessage } from "../Intl/Context";
import { useRoutesContext } from "../Routes/RoutesContext";
import { isAuthorized } from "../Utils/authorizations";

import { startForm } from "../../mutations/StartFormMutation";

const FormDisclaimer = props => {
  const contribution = useFragment(FormDisclaimer_contribution, props.contribution);

  const { participativeModule } = contribution;
  const { disclaimer } = participativeModule;

  const allowSignedInAnonymousContributions = isAuthorized(
    contribution.authorizations.toggleAnonymousMode
  );

  const t = useFormatMessage();

  const title = t(intlMessages.title);
  const submitLabel = t(intlMessages.submit);
  const signInMessage = t(intlMessages.signInMessage);
  const anonymousContributionTitle = t(intlMessages.anonymousContributionTitle);
  const anonymousContributionLabel = t(intlMessages.anonymousContributionLabel);
  const nonAnonymousContributionLabel = t(intlMessages.nonAnonymousContributionLabel);
  const anonymousContributionDescription = t(
    intlMessages.anonymousContributionDescription
  );

  const { pathFor } = useRoutesContext();
  const participativeModulePath = pathFor("participativeModule", {
    participativeModuleSlug: participativeModule.slug
  });

  const breadcrumbs = [
    { title: participativeModule.title, url: participativeModulePath },
    { title }
  ];

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [anonymous, setAnonymous] = useState(false);

  const handleStartButtonClicked = useCallback(() => {
    setIsSubmitting(true);

    startForm({ participativeModuleId: participativeModule.id, anonymous });
  }, [participativeModule.id, anonymous]);

  const handleAnonymousChange = useCallback(e => setAnonymous(e), [setAnonymous]);

  const anonymousBoxClassName = classNames("box", "padding-md", "margin-bottom-xs", {
    "bg-secondary": anonymous,
    "text-white": anonymous
  });

  const anonymousHintClassName = classNames("form-text", {
    "text-white": anonymous
  });

  return (
    <Modal
      breadcrumbs={breadcrumbs}
      title={title}
      className="modal-sm modal-with-actions"
    >
      {disclaimer && (
        <div className="box padding-md margin-bottom-xs">
          <div
            className="participative-module-disclaimer"
            dangerouslySetInnerHTML={{ __html: disclaimer }}
          />
        </div>
      )}

      {allowSignedInAnonymousContributions && (
        <div className={anonymousBoxClassName}>
          <h2 className="text-title-section margin-bottom-sm">
            {anonymousContributionTitle}
          </h2>

          <p className={anonymousHintClassName}>{anonymousContributionDescription}</p>

          <div className="d-flex align-items-center justify-content-between">
            <span className="margin-right-sm">
              {anonymous ? anonymousContributionLabel : nonAnonymousContributionLabel}
            </span>

            <AnonymousContributionSwitch
              anonymous={anonymous}
              handleAnonymousChange={handleAnonymousChange}
            />
          </div>
        </div>
      )}

      <div className="modal-actions modal-buttons-container">
        <FormStartButton
          onSignIn={handleStartButtonClicked}
          submitLabel={submitLabel}
          signInMessage={signInMessage}
          isSubmitting={isSubmitting}
        />
      </div>
    </Modal>
  );
};

const FormDisclaimer_contribution = graphql__29da1a4fd9c50a8f7943;

export default FormDisclaimer;

const intlMessages = defineMessages({
  title: {
    id: "formDisclaimer.title",
    defaultMessage: "Soumettre un projet"
  },
  submit: {
    id: "formDisclaimer.submit",
    defaultMessage: "Démarrer"
  },
  signInMessage: {
    id: "formDisclaimer.signInMessage",
    defaultMessage: `
      Vous devez vous connecter ou créer un compte afin de pouvoir
      déposer votre projet.
      <br>
      Les informations de votre compte nous permettent entre autres de vous
      contacter pour vous tenir informer le l'état d'avancement de votre
      candidature.
    `
  },
  anonymousContributionTitle: {
    id: "formDisclaimer.anonymousContributionTitle",
    defaultMessage: "Choisir votre mode de contribution"
  },
  anonymousContributionDescription: {
    id: "formDisclaimer.anonymousContributionDescription",
    defaultMessage: `
      Contribuez en votre nom afin de pouvoir être identifié comme auteur de votre 
      contribution, ou choisissez de contribuer anonymement si vous ne souhaitez pas que
      votre nom soit associé à votre contribution.
    `
  },
  anonymousContributionLabel: {
    id: "formDisclaimer.anonymousContributionLabel",
    defaultMessage: "Je contribue anonymement"
  },
  nonAnonymousContributionLabel: {
    id: "formDisclaimer.nonAnonymousContributionLabel",
    defaultMessage: "Je contribue en mon nom"
  }
});
